import { CalendarDaysIcon, Input, MultiSearchForm } from "@";
import type { StatisticsSearchValues } from "../types.ts";

interface MultiSearchProps {
  onSubmit: () => void;
  search: {
    show: boolean;
    values: StatisticsSearchValues;
  };
  updateSearch: (params: { values: {} }) => void;
  onReset: () => void;
}

const MultiSearch = ({
  onSubmit,
  search,
  updateSearch,
  onReset,
}: MultiSearchProps) => {
  const handleInputChange = (
    field: keyof StatisticsSearchValues,
    value: unknown,
  ) => {
    updateSearch({ values: { [field]: value } });
  };

  return (
    <div className="relative mb-6 mt-4 rounded-2xl border border-gray-100 bg-gradient-to-l from-purple-50/30 via-white to-purple-50/20 p-4 dark:border-gray-700/60 dark:from-purple-950/15 dark:via-gray-800 dark:to-purple-950/10 md:mt-6">
      <div className="relative mb-3 flex items-center gap-2.5">
        <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-purple-50 text-purple-700 ring-1 ring-purple-100 dark:bg-purple-950/40 dark:text-purple-300 dark:ring-purple-800/40">
          <CalendarDaysIcon className="h-5 w-5" />
        </span>
        <div>
          <p className="text-[10px] font-semibold uppercase tracking-[0.18em] text-purple-700 dark:text-purple-400">
            نطاق الإحصائيات
          </p>
          <p className="text-xs text-gray-500 dark:text-gray-400">
            حدد الفترة الزمنية للحصول على البيانات
          </p>
        </div>
      </div>

      <div className="relative">
        <MultiSearchForm
          show={true}
          onSubmit={onSubmit}
          reset={onReset}
          style="border-none p-0"
          className="multi-search-form"
        >
          <Input
            star
            showTimeSelect
            style="xl:col-span-3"
            type="date-range"
            labelA="من تاريخ"
            labelB="إلى تاريخ"
            valueA={search.values.fromDate}
            valueB={search.values.toDate}
            changeA={(e: Date | null) => handleInputChange("fromDate", e)}
            changeB={(e: Date | null) => handleInputChange("toDate", e)}
          />
        </MultiSearchForm>
      </div>
    </div>
  );
};

export default MultiSearch;
